import { render, staticRenderFns } from "./B2BSettings.vue?vue&type=template&id=02604586&scoped=true&"
import script from "./B2BSettings.vue?vue&type=script&lang=js&"
export * from "./B2BSettings.vue?vue&type=script&lang=js&"
import style0 from "./B2BSettings.vue?vue&type=style&index=0&id=02604586&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02604586",
  null
  
)

export default component.exports